import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IonBadge, IonToggle } from '@ionic/angular/standalone';

/**
 * WORKAROUND COMPONENT
 *
 * This component exists solely to work around an issue with the Angular build optimizer
 * (in Angular 19+ using the 'application' builder) incorrectly removing CSS classes
 * for Ionic components when styles/states are applied dynamically (e.g., [color]="...", [checked]="...").
 *
 * By including static instances of these components with the problematic attributes/states
 * in this component's template, we force the build optimizer to retain the necessary CSS.
 *
 * This component is hidden via CSS (`display: none`) and included once in AppComponent.
 *
 * See related discussion: https://github.com/ionic-team/ionic-framework/issues/30100
 */
@Component({
  selector: 'app-build-optimizer-bugfix',
  templateUrl: './build-optimizer-bugfix.component.html',
  styleUrls: ['./build-optimizer-bugfix.component.scss'],
  standalone: true,
  imports: [
    IonBadge, // Import necessary Ionic standalone components
    IonToggle,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuildOptimizerBugfixComponent {}
